import { motion } from "framer-motion";

const WORDS = [
  "Таро",
  "Судьба",
  "Интуиция",
  "Ладонь",
  "Совместимость",
  "Число судьбы",
  "Предназначение",
  "Тайна имени",
];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section
      className="relative overflow-hidden border-y border-[#D4AF6E]/12 bg-[#0d0d24] py-8"
      data-testid="marquee"
      aria-hidden="true"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
      >
        {items.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-serif text-3xl italic text-[#EDE6D3]/70 sm:text-5xl">
              {w}
            </span>
            <span className="text-2xl text-[#D4AF6E]/60 sm:text-4xl">✦</span>
          </span>
        ))}
      </motion.div>
    </section>
  );
};
